import { schema } from "normalizr";

const availabilityType = new schema.Entity(`availability_types`);
const arrayOfAvailabilityTypes = [availabilityType];

export { availabilityType, arrayOfAvailabilityTypes };
